export default __webpack_public_path__ + "static/section_6_details_4-516a7f6817bf5b4962c6e05277cff392.png";